export class ScreeningStepManager {
    public static nextStep(actualStep: string, isDiverge: boolean = false) {

        switch (true) {
            case actualStep === 'gravacao':
                return 'imei';
            case actualStep === 'imei':
                return 'checklist';
            case actualStep === 'checklist' && isDiverge:
                return 'laudo';
            case actualStep === 'checklist' && !isDiverge:
                return 'resultado';
            case actualStep === 'resultado':
                return 'resultado';
            case actualStep === 'laudo':
                return 'laudo';
            default:
                return 'gravacao';
        }
    }
}
